module.exports = __webpack_public_path__ + "img/5.a76f09b5.jpg";